import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'formatPhone'
})
export class FormatPhonePipe implements PipeTransform {

    transform(value: string | null): unknown {
        if (!value) return '';
        const cleaned = value.replace(/\D/g, ''); // Remove non-digits
        if (cleaned.length === 10) {
            return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
        }
        return value;
    }
}
